import { useTranslation } from "react-i18next";
import MScreen from "../../components/pos/MScreen";
import DoneIcon from "@mui/icons-material/Done";
import MText from "../../components/pos/MText";
import { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import db from "../../db/db";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { AgentUtils } from "../../utils/AgentUtils";

const theme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "1.10rem",
          padding: 5,
        },
        head: {
          lineHeight: "2rem",
          fontSize: "1rem",
          padding: 0,
        },
        paddingCheckbox: {
          width: 0,
        },
      },
    },

    MUIDataTableHeadCell: {
      styleOverrides: {
        fixedHeader: {
          padding: "5px",
        },
      },
    },
  },
});

export default function MCustomerSearch(props, ref) {
  const { t, i18n } = useTranslation();
  const translate = t;

  const [customerList, setCustomerList] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [customerSearchText, setCustomerSearchText] = useState("");

  useEffect(() => {
    loaadByDB(null);
  }, []);

  const open = Boolean(anchorEl);

  function handleClick(event, value) {
    setAnchorEl(event.currentTarget);
    setSelectedCustomer(value);
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  function onMenuItemClicked(key) {
    setAnchorEl(null);
    if (key === "SELECT") {
      console.log("Select clicked");
    }
  }

  async function loaadByDB(searchVal) {
    if (searchVal && searchVal !== "") {
      let customerList = await db.customer
        .orderBy("name")
        .filter(function (customer) {
          return (
            customer.name.toLowerCase().includes(searchVal.toLowerCase()) ||
            customer.mobile.startsWith(searchVal)
          );
        });
      customerList.toArray(function (data) {
        setCustomerList(data);
      });
    } else {
      db.customer.toArray(function (data) {
        setCustomerList(data);
      });
    }
  }

  async function handleCustomerSearchChange(searchVal) {
    loaadByDB(searchVal);
  }

  const columns = [
    {
      name: "Customer",
      options: {
        filter: false,
        sort: false,
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={12}
                  style={{
                    marginTop: "8px",
                    marginLeft: "3px",
                    marginRight: "3px",
                  }}
                >
                  <MText
                    label="Search here"
                    value={customerSearchText}
                    onChange={(e) => {
                      handleCustomerSearchChange(e.target.value);
                      setCustomerSearchText(e.target.value);
                    }}
                  ></MText>
                </Grid>
              </Grid>
            </div>
          );
        },
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <table width="100%">
              <tbody>
                <tr>
                  <td>
                    <Grid container>
                      <Grid item xs={12}>
                        <div>
                          {tableMeta.tableData[tableMeta.rowIndex].name}
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <div style={{ fontSize: "0.75rem" }}>
                          Micr:{" "}
                          <b>
                            {tableMeta.tableData[tableMeta.rowIndex].micrCode}
                          </b>{" "}
                          Credit:{" "}
                          <b>
                            {tableMeta.tableData[tableMeta.rowIndex]
                              .creditCustomer
                              ? "YES"
                              : "NO"}
                          </b>{" "}
                          Mob:
                          <b>
                            {" "}
                            {tableMeta.tableData[tableMeta.rowIndex].mobile}
                          </b>
                        </div>
                      </Grid>
                    </Grid>
                  </td>
                  <td width="5%" align="right">
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={(event) => {
                        handleClick(
                          event,
                          tableMeta.tableData[tableMeta.rowIndex]
                        );
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id="long-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={open}
                      onClose={handleClose}
                      PaperProps={{
                        style: {
                          maxHeight: 70,
                          width: "20ch",
                        },
                      }}
                    >
                      <MenuItem
                        key={
                          tableMeta.tableData[tableMeta.rowIndex].id + "SELECT"
                        }
                        onClick={() => {
                          props.onCustomerSelect(selectedCustomer);
                          props.setCurrentScreen("sale");
                        }}
                      >
                        Select
                      </MenuItem>
                    </Menu>
                  </td>
                </tr>
              </tbody>
            </table>
          );
        },
      },
    },
  ];

  const options = {
    textLabels: {
      body: {
        noMatch: "No customer found",
      },
    },
    filterType: "checkbox",
    filter: false,
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    title: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    pagination: false,
    responsive: "standard",
    pagination: true,

    tableBodyHeight:
      (AgentUtils.getWindowDimensionsExAppBars().h - 70).toString() + "px",
    rowsPerPage: Math.round(
      (AgentUtils.getWindowDimensionsExAppBars().h - 70 - 128) / 58
    ),
    rowsPerPageOptions: [
      Math.round((AgentUtils.getWindowDimensionsExAppBars().h - 70 - 128) / 58),
      15,
      50,
      100,
    ],

    textLabels: {
      pagination: {
        rowsPerPage: "Rows",
      },
    },
    setRowProps: (row, dataIndex, rowIndex) => {
      if (customerList[rowIndex]["isSelected"]) {
        return {
          style: { background: "#FFCC99" },
        };
      }
    },
    onRowClick: (rowData, rowMeta, rowIndex) => {
      var data = [...customerList];
      for (let i = 0; i < customerList.length; i++) {
        if (customerList[i]["isSelected"]) {
          customerList[i]["isSelected"] = false;
        }
      }
      setSelectedCustomer(customerList[rowMeta.rowIndex]);
      customerList[rowMeta.rowIndex]["isSelected"] = true;
      setCustomerList(data);
    },
  };
  const content = (
    <div>
      <ThemeProvider theme={theme}>
        <MUIDataTable data={customerList} columns={columns} options={options} />
      </ThemeProvider>
    </div>
  );

  return (
    <MScreen
      title={props.textLabel}
      isMoreMenuEnabled={false}
      onRedirectToBack={() => props.setCurrentScreen("sale")}
      rightAction={translate("Select")}
      onRightAction={() => {
        props.onCustomerSelect(selectedCustomer);
        props.setCurrentScreen("sale");
      }}
      rightActionIcon={<DoneIcon></DoneIcon>}
      enbaleRightAction={true}
      onLogOut={props.onLogOut}
      content={content}
    ></MScreen>
  );
}
